/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum TaskStatus {
  complete = 'complete',
  incomplete = 'incomplete'
}

/**
 * TaskStatus
 *
 * The supported backing snapshot from providers.
 */
export const TaskStatusEnumType = types.enumeration('TaskStatus', ['complete', 'incomplete'])
